import { Col, Row } from "antd";
import HeroDivider from "/app/src/components/HeroUi/Divider";
import { Helmet } from "react-helmet";
import "./_updateLicense.scss";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";
import { useTranslation } from "react-i18next";
import homeIcon from "/app/src/images/home-alt.svg";
import { useStatusContext } from "/app/src/contexts/hooks/useStatusContext";
import UpdateLicenseForm from "./updateLicenseForm";
import Box from "/app/src/components/generic/components/box";

/**
 *
 * @returns Update License form header
 */
export default function UpdateLicenseFormHeader() {
  const { t } = useTranslation();
  const { activeWarehouses } = useStatusContext();

  return (
    <div>
      <Helmet>
        <title>{t("translation:update_license")} - ItemPath</title>
      </Helmet>
      <Row>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20, offset: 2 }}
          lg={{ span: 12, offset: 6 }}
        >
          <Box>
            <div className="licenseInfo">
              <div>
                <span>
                  <IconBuilder icon="Warning" color="#a65900" size={20} />
                </span>
                <span className="header">
                  {t("translation:update_your_license")}
                </span>
              </div>
              <span>
                <div className="homeIconContainer">
                  <img src={homeIcon} alt="Home" className="homeIcon" />
                </div>
                <span className="subHeader" style={{ paddingLeft: 10 }}>
                  {t("translation:active_warehouses")}:
                </span>
                <span className="smLicenseLimit" style={{ paddingLeft: 4 }}>
                  {activeWarehouses}
                </span>
              </span>
            </div>
            <span className="paragraph">
              {t("translation:warehouse_exceeded")}
            </span>
            <HeroDivider className="my-6" />
            <UpdateLicenseForm />
          </Box>
        </Col>
      </Row>
    </div>
  );
}
